export default __webpack_public_path__ + "static/media/Category=Wystawa.fe9cb61a.png";